import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  BooleanInput,
  ImageField,
  ImageInput,
  ReferenceInput,
  SelectInput,
  required,
} from "react-admin";
import { Grid } from "@mui/material";

/**
 * Formulaire de création d’un “stay”.
 * - ImageInput fournit { rawFile, src, title } quand on choisit un fichier.
 * - Le dataProvider détecte rawFile, uploade, puis remplace par l’URL avant l’envoi.
 * - format/parse permettent aussi d’afficher une URL existante en édition (si tu réutilises ce bloc).
 */
export const StayCreate = () => (
  <Create>
    <SimpleForm>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextInput source="title" label="Titre" validate={required()} fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <NumberInput source="price" label="Prix" min={0} fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <BooleanInput source="is_active" label="Actif" defaultValue={true} />
        </Grid>

        {/* Exemple de relation si besoin */}
        <Grid item xs={12} md={6}>
          <ReferenceInput source="category_id" reference="category">
            <SelectInput optionText="name" label="Catégorie" />
          </ReferenceInput>
        </Grid>

        <Grid item xs={12} md={6}>
          <ImageInput
            source="image"
            label="Image"
            accept="image/*"
            multiple={false}
            placeholder={<p>Sélectionnez votre image</p>}
            validate={required()}
            // Si on réutilise ce composant pour l’édition, ceci affiche une URL existante :
            format={(value) =>
              typeof value === "string" ? { src: value, title: "Image" } : value
            }
            // À la soumission, on renvoie tel quel (le dataProvider gère l’upload si rawFile)
            parse={(value) => value}
          >
            <ImageField source="src" title="Image" />
          </ImageInput>
        </Grid>
      </Grid>
    </SimpleForm>
  </Create>
);

export default StayCreate;
